import React from 'react'
import { array, number, string } from 'prop-types'

import Typography from 'components/atoms/Typography'

const RIASECBox = ({
  sortedKey,
  label,
  text,
  score,
}) => {
  const characterRank = sortedKey.indexOf(label)
  const background = ['#0056b3', '#00beff', '#00beff']
  const bgColor = background[characterRank] ||  '#fff'
  return (
    <div className="riasec-box" style={{ backgroundColor:  bgColor }}>
      <Typography component="h6" variant="subheading" className="font-bolder" style={{ color: (background[characterRank] && '#fff') || '#1e3f6b' }}>{label}: {text}</Typography>
      <Typography component="h6" variant="subheading" className="font-bolder" style={{ color: (background[characterRank] && '#fff') || '#8fb0d4' }}>{Math.floor(score)}%</Typography>
      <style jsx>
        {`
          .riasec-box {
            display: flex;
            justify-content: space-between;
            padding: 15px 25px;
            box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1);
            border-radius: 8px;
            margin-bottom: 10px;
          }
        `}
      </style>
    </div>
  )
}

RIASECBox.propTypes = {
  sortedKey: array,
  label: string,
  text: string,
  score: number,
}

export default RIASECBox
